import {
  Directive,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';

import { CharacterConfig } from '../configs/character.config';
import { ArrowEvent } from '../interfaces/common.interface';

interface KeyPressLineItemsInterface {
  rowKey :number;
  columnKey :number;
  rowClass :string;
  parentId :string;
  key ?:number;
}

@Directive({
  selector: '[lumKeyPressLineItems]',
})
export class KeyPressLineItemsDirective {
  @Input()
  lumKeyPressLineItems :KeyPressLineItemsInterface;

  @Output()
  move = new EventEmitter<ArrowEvent>();
  @HostListener('keydown', ['$event'])
  handleKeyDown(event :KeyboardEvent) {
    const { ctrlKey, key, metaKey } = event;
    this.lumKeyPressLineItems.key = this.getKey({
      rowKey: this.lumKeyPressLineItems.rowKey,
      columnKey: this.lumKeyPressLineItems.columnKey,
      rowClass: this.lumKeyPressLineItems.rowClass,
    });

    const parentEl = document.getElementById(this.lumKeyPressLineItems.parentId);

    // Get elements by type input and mat-select
    const inputs = parentEl?.querySelectorAll(
      'input, mat-select, mat-select-trigger',
    );

    const rowParent = document.getElementById(this.lumKeyPressLineItems.rowClass);
    const rowInputs = rowParent?.querySelectorAll(
      'input, mat-select, mat-select-trigger',
    ).length;

    let el :any;

    if (ctrlKey || metaKey) {
      if (CharacterConfig.allowedKeys.indexOf(key) === -1) {
        event.preventDefault();
      }

      switch (key) {
        case ArrowEvent.ARROW_UP:
          if (inputs) {
            el = inputs[this.lumKeyPressLineItems.key - (rowInputs || 0)];
            if (el) {
              // Check if element is an input and type number
              if (el.type === 'number') {
                el.select();
              }
              el.focus();
            }
          }

          break;

        case ArrowEvent.ARROW_DOWN:
          if (inputs) {
            el = inputs[this.lumKeyPressLineItems.key + (rowInputs || 0)];
            if (el) {
              if (el.type === 'number') {
                el.select();
              }
              el.focus();
            }
          }
          break;

        case ArrowEvent.ARROW_LEFT:
          if (inputs) {
            el = inputs[this.lumKeyPressLineItems.key - 1];
            if (el) {
              event.preventDefault();
              if (el.type === 'number') {
                el.select();
              }
              el.focus();
            }
          }
          break;

        case ArrowEvent.ARROW_RIGHT:
          if (inputs) {
            el = inputs[this.lumKeyPressLineItems.key + 1];
            if (el) {
              if (el.type === 'number') {
                el.select();
              }
              el.focus();
            }
          }
          break;

        default:
          break;
      }
    }
  }

  getKey(data :{ columnKey :number; rowKey :number; rowClass :string }) :number {
    const { rowKey, columnKey, rowClass } = data;
    let inputs = 0;
    const parentEl = document.getElementById(rowClass);
    if (parentEl) {
      inputs = parentEl.querySelectorAll(
        'input, mat-select, mat-select-trigger',
      ).length;
    }

    return columnKey + rowKey * inputs;
  }
}
